export const transportData = {
  route: "Vaal → Venda",


dropoffLocations: [
    "Thohoyandou Thavhani Mall 09:30am",
    "Zwikwengani",
    "Tshakhuma",
    "Elim",
    "Nzhelele",
    "Louis Trichardt 11:30am",
    "Polokwane",
    "Naboom"
  ],

    pickupPoints: [
    "Vaal University of Technology Main Gate  ",
    "North-West University (Vanderbijlpark)",
    "Midrand New Road Engen"
  ],
  pickupTransport: [
    "Vaal → Venda",
    "Vaal → Gaza",
    "Venda → JHB"
  ],

  travelDates: [
    "14 November  Saturday 18:00pm",
    "21 November  Saturday 18:00pm",
    "27 November  Friday 18:00pm", 
    "30 November  Friday 18:00pm"
  ],

  fleet: [
    "15 Seater Taxi",
    "22 Seater Bus",
    "50 Seater Bus",
    "70 Seater Bus"
  ],

  pricing: {
    totalPrice: "anging From 499.99",
    deposit: "100",
    // Fares that differ from totalPrice, by drop-off location
    dropoffPrices: {
      Polokwane: "460",
      Naboom: "460"
    }
  },

  contact: {
    whatsapp: "27728009120",
    displayWhatsapp: "+27 72 800 9120",
    whatsappGroup: "https://chat.whatsapp.com/G6jjjAdncfu2AklOTtjj1D",
    email: "arenaho@gmail.com"
  },

  banking: {
    bank: "Capitec",
    accountNumber: "1731201611",
    accountOwner: "A MUHALI",
    reference: "Your Name + WhatsApp Number"
  }, 

    publicKey: "",// The secret key (sk) will be blocked by Yoco when called directly from a browser for security reasons.
 

};